import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SearchObjectService } from '../../shared/services/search-object.service';
import { SERVICE_URL } from '../../tokens';
import { UserRulesService } from 'src/app/shared/services/user-rules.service';

@Injectable({
  providedIn: 'root',
})
export class SearchDetailsService {

    // replace with variable url and key
    private providerDetailsUrl;
    private locationPractitionersUrls;

    constructor(private http: HttpClient, private searchObjectService: SearchObjectService,
      private userRulesService: UserRulesService,
        @Inject(SERVICE_URL) private serviceUrl: any) {
            this.providerDetailsUrl = `${this.serviceUrl}ProviderDetails`;
            this.locationPractitionersUrls = `${this.serviceUrl}LocationPractitioners`;
        }

    getProviderDetails(providerId, networkId, subproductkey, searchYear): Observable<any> {
        return this.http.get(this.providerDetailsUrl, {params: this.getParamsObject(providerId, networkId, subproductkey, searchYear)});
    }

    getLocationPractitioners(providerId, networkId, officeid, subproductkey, searchYear): Observable<any> {
        return this.http.get(this.locationPractitionersUrls, {params: this.getLocationParamsObject(providerId, networkId, officeid, subproductkey, searchYear)});
    }

    getParamsObject(providerId, networkId, subproductkey, searchYear): HttpParams {
        const searchObject = this.searchObjectService.getSearchObject();
        const fromObject = {
            'providerId' : providerId,
            'networkId' : networkId,
            'latitude' : searchObject.lat,
            'longitude' : searchObject.long,
            'subProductKey' : subproductkey ? subproductkey : '',
            'planYear' : searchYear ? searchYear : '',
            'isPcpSearch' : this.userRulesService.isUserPCP() ? true : false
        };

        const params = new HttpParams({
            fromObject: this.removeEmpty(fromObject)
        });

        return params;

    }

    getLocationParamsObject(providerId, networkId, officeId, subproductkey, searchYear): HttpParams {
        const fromObject = {
            'officeId': officeId,
            'providerId' : providerId,
            'networkId' : networkId,
            'subProductKey' : subproductkey ? subproductkey : '',
            'planYear' : searchYear ? searchYear : ''
        };

        const params = new HttpParams({
            fromObject: this.removeEmpty(fromObject)
        });

        return params;
    }

    // TODO: make into pipe?
    removeEmpty = (obj) => {
        Object.keys(obj).forEach(key => {
            if (!obj[key]) {
              delete obj[key];
            }
          });
        return obj;
    }
}
